import { StudySearchClient } from '../domain';
import { PortalMap, PortalType } from '@studyportals/domain-client';

/* eslint-disable
	id-denylist
 */

declare const STUDY_SEARCH_SERVICE_URL: string;

const studySearchAPIUrl = STUDY_SEARCH_SERVICE_URL;

const portalMap: PortalMap = window['PortalMap']
	? (new Map(Object.entries(window['PortalMap'] as Record<PortalType, string>)) as Map<PortalType, string>)
	: new Map<PortalType, string>();
const studySearchClient = new StudySearchClient(studySearchAPIUrl, portalMap);

export default studySearchClient;
